import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getMeasurementsByUser = async(token) => {
  const url = `${generateEndpoint('getMeasurementsUser')}`
  return fetchGet(url, token)
}